module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_okinawa_plans-d07cf888922d57eed352f445305299cc.jpg";